<template>
  <md-toolbar md-elevation="0" class="landing-header">
    <div class="container">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <SLogo class="py-2" />
        </div>
        <SSearchTopBar class="desktop-search" />
        <div class="md-toolbar-section-end">
          <div class="header-login">
            <md-button
              class="login-button"
              @click="refreshLoginPage"
              data-cy="tbLoginBtn"
              >LOG IN</md-button
            >
          </div>
          <div class="header-register">
            <md-button class="register-button" @click="refreshRegisterPage">
              REGISTER
            </md-button>
          </div>
        </div>
      </div>
      <div class="md-toolbar-row mobile-search-row">
        <SSearchTopBar class="mobile-search" />
      </div>
    </div>
  </md-toolbar>
</template>
<script>
import SLogo from "@/material-components/atoms/SLogo.vue";
import SSearchTopBar from "@/material-components/organisms/SSearchTopBar.vue";

export default {
  name: "SLandingTopBar",
  components: {
    SLogo,
    SSearchTopBar,
  },
  methods: {
    refreshLoginPage() {
      if (this.$route.name === "loginPage") {
        this.$router.go();
        return;
      }
      this.$router.push("/login").catch(() => {});
    },
    refreshRegisterPage() {
      if (this.$route.name === "registerPage") {
        this.$router.go();
        return;
      }
      this.$router.push("/signup").catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-width: 100%;
}
.desktop-search {
  display: none;
  width: 40%;
}
.mobile-search {
  width: 100%;
  margin-top: 10px;
}
.landing-header {
  position: fixed;
  width: 100%;
  z-index: 19;
  background-color: $light !important;
}
.login-button {
  height: 2.1em;
  left: 0.21em;
}
.register-button .md-size-2x:hover {
  color: $primary-light !important;
}
@media screen and (max-width: 1023px) {
  .mobile-search .mobile-search-row {
    display: block;
  }
  .desktop-search {
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  .desktop-search {
    display: block;
  }
  .mobile-search,
  .mobile-search-row {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.header-register {
  padding-left: 1.2em;
}
.register-button {
  background-color: $primary;
  color: $light !important;
  height: 34px;
  width: 96px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 1.25px;
  border-radius: 5px;
}
.login-button {
  color: $primary !important;
  font-size: 14px !important;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 1.25px;
}
</style>
